import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const SidebarAtom = atomWithStorage('sidebarOpen', false)
export const SidebarHoverAtom = atom(false)
export const openChangeClientAtom = atom(false)
export const addLayersDialogAtom = atom(false)

SidebarAtom.debugLabel = 'NewSidebarAtom'
SidebarAtom.debugLabel = 'SidebarHoverAtom'
openChangeClientAtom.debugLabel = 'openChangeClientAtom'
addLayersDialogAtom.debugLabel = 'addLayersDialogAtom'
